import CustomButton from "../../../components/CustomButton";
import { useAppDispatch } from "../../../redux/hooks";
import { UnreceivedGoodsDataInterface } from "../../../redux/interfaces/receipt.interface";
import { deleteUnreceivedGoods } from "../../../redux/api/receipt.api";
import SvgIcon from "../../../helpers/SvgIcon";

function UnreceivedGoodsActionButtons({
  itemId,
}: {
  itemId: string;
  crudData: UnreceivedGoodsDataInterface;
}) {
  const dispatch = useAppDispatch();

  const handleDelete = () => {
    dispatch(
      deleteUnreceivedGoods({
        id: itemId,
      }),
    );
  };

  return (
    <div>
      <CustomButton
        variant="contained"
        tooltipTitle="Sterge"
        color="error"
        className="mt-1 me-1"
        withConfirmationModal={{
          modalLeftButtonVariant: "outlined",
          modalTitle: `Doriti sa stergeti produsele?`,
          modalRightButtonOnClick: handleDelete,
        }}>
        <SvgIcon type="DELETE" fill="white" />
      </CustomButton>
    </div>
  );
}

export default UnreceivedGoodsActionButtons;
